
import Approval from "locales/dental/th/approval/approval.json"
import ApprovelList from "locales/dental/th/approval/approvelList.json"

export const ApprovalTH ={
    ...Approval,
    ...ApprovelList
    
}